import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Button from './button';
import { rightArrowBlack } from './images/svg/icons';
import { getItem, getLocalizedPathFromLocalStorage } from '../helper/localstorage.helper';
import '../scss/freelance-life.style.scss';
import { use } from 'i18next';
import { RootState } from '../store';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';


interface FreelancerCtaSectionProps {
  title: string;
  description: string[];
  buttonText: string;
  imageSrc: string;
  imageAlt?: string;
}

interface RootState {
  auth: {
    user: string | null;
  };
}

const FreelancerCtaSection: React.FC<FreelancerCtaSectionProps> = ({
  title,
  description,
  buttonText,
  imageSrc,
  imageAlt = '',
}) => {
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.auth.user);
  const { t } = useTranslation();
  const handleRegisterClick = () => {
    navigate(getLocalizedPathFromLocalStorage({ get: (key: string) => getItem(key) ?? null }, user ? { 'sv-se': 'instrumentbrada/aktiviteter', 'en-us': 'dashboard/activities' } : { 'sv-se': 'e-postregister', 'en-us': 'emailregister' }));
  };

  return (
    <section className="cta-section-freelance">
      <Container>
        <Row className="align-items-start">
          <Col md={6} className="mb-4 mb-md-0 px-0">
            <div className="cta-content">
              <h2 className="cta-title mb-3 text-light">{title}</h2>
              <div className="cta-description  mb-4 mr-sm-5 pr-sm-5">
                {description.map((desc, idx) => (
                  <p key={idx} className='text-white-25'>{desc}</p>
                ))}
              </div>
              <Button onClick={handleRegisterClick}>
                {user ? t('GO_TO_DASHBOARD') : t('CREATE_FREE_ACCOUNT')}
                <img src={rightArrowBlack} className="ms-1 mb-1" alt="" style={{ marginLeft: '6px' }} />
              </Button>
            </div>
          </Col>
          <Col md={6} className="text-end px-0">
            <img src={imageSrc} alt={imageAlt} className="img-fluid" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FreelancerCtaSection;
